import React, { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { t } from "@/lib/i18n";

// Muestra una imagen protegida de GridFS (requiere token) descargándola como blob.
export default function AuthImage({ fileId, alt = "documento", className = "" }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let revoked = null;
    setUrl(null); setError(false);
    api.get(`/documentos/${fileId}`, { responseType: "blob" })
      .then((res) => { const u = URL.createObjectURL(res.data); revoked = u; setUrl(u); })
      .catch(() => setError(true));
    return () => { if (revoked) URL.revokeObjectURL(revoked); };
  }, [fileId]);

  if (error) return <div className={`flex items-center justify-center bg-paper text-ink-3 text-xs ${className}`}>{t("No disponible")}</div>;
  if (!url) return <div className={`flex items-center justify-center bg-paper ${className}`}><Loader2 className="h-5 w-5 animate-spin text-ink-3" /></div>;
  return <img src={url} alt={alt} className={className} />;
}
